var map = {
	"./casabala3.webp": 5429,
	"./gallery-0.webp": 3705,
	"./gallery-1.webp": 2814,
	"./gallery-15.webp": 8521,
	"./gallery-16.webp": 556,
	"./gallery-2.1.webp": 5010,
	"./gallery-2.webp": 9967,
	"./gallery-22.1.webp": 6210,
	"./gallery-22.webp": 1807,
	"./gallery-23.webp": 7516,
	"./gallery-24.webp": 845,
	"./gallery-26.webp": 9875,
	"./gallery-27.webp": 6176,
	"./gallery-28.webp": 6241,
	"./gallery-3.webp": 8428,
	"./gallery-6.webp": 8403,
	"./gallery-7.webp": 912,
	"./gallery-8.1.webp": 8264,
	"./gallery-8.webp": 1,
	"./gallery-9.webp": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5690;